import React from 'react';
import {Datagrid, EditButton, DeleteButton, List, TextField, NumberField, DateField} from 'react-admin';

const StoryList = (props: any) => (
    <List {...props} perPage={25} bulkActionButtons={false} sort={{ field: 'order', order: 'ASC' }}>
        <Datagrid>
            <NumberField source="order" />
            <NumberField source="number" />
            <TextField source="title" />
            <DateField source="begin" />
            <DateField source="end" />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export default StoryList;
